export const unknown = (source, input) => ({
    type: 'unknown',
    source,
    dir: 'auto',
    toParts: () => [{ type: 'unknown', value: input }],
    toString: () => String(input),
    valueOf: () => input
});
